<rk-modal-wrapper
  (submitted)="onSubmit()"
  (cancelled)="onCancel()"
  (closed)="onCancel()"
  [title]="'MEDIA.MODAL.TRACK.EDIT.TITLE_MULTIPLE' | translate"
  [loading]="isLoading$ | async"
  [hideCancelOnLoading]="true"
>
  <div
    class="content"
    [innerHTML]="
      'MEDIA.MODAL.TRACK.EDIT.HEADER_MULTIPLE' | translate: { tracks: trackLength() }
    "
  ></div>
</rk-modal-wrapper>
